import gql from "graphql-tag";

export const assetFragment = gql`
  fragment assetFragment on assets_Asset {
    id
    url(transform: "default")
    width
    height
    title
    alt
    caption
    kind
    extension
    w480: url @transform(width: 480, format: "webp")
    w720: url @transform(width: 720, format: "webp")
    w960: url @transform(width: 960, format: "webp")
    w1440: url @transform(width: 1440, format: "webp")
    w2160: url @transform(width: 2160, format: "webp")
  }
`;

export type AssetFragment = {
  id: string;
  url: string;
  width: number | null;
  height: number | null;
  title: string | null;
  alt: string | null;
  caption: string | null;
  kind: string | null;
  extension: string | null;
  w480: string | null;
  w720: string | null;
  w960: string | null;
  w1440: string | null;
  w2160: string | null;
};
